import Button from '../common/Button';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { useGlobalSettings } from '../../hooks/useGlobalSettings';
import Animation from '../common/Animation';
import { useAvatar } from '../../hooks/useAvatar';
import { useStartpageData } from '../../hooks/pages/useStartpageData';

export default function StartPage({ station, theme }) {
  const navigate = useNavigate();

  const { data: pageData, error: pageDataError } = useStartpageData(station);
  const { globalSettings, error: globalSettingsError } = useGlobalSettings();
  const { avatarData, error: avatarDataError } = useAvatar('Startseite');

  if (globalSettingsError || pageDataError || avatarDataError) {
    return <div>Fehler: {globalSettingsError || pageDataError || avatarDataError}</div>;
  }

  if (!globalSettings || !pageData || !avatarData) {
    return <div>Laden...</div>;
  }

  const { question, buttons } = pageData;
  const { logoUrl } = globalSettings;
  const avatar = avatarData[0]?.animation;

  if (!buttons) {
    return <div>Fehler: Buttons konnten nicht geladen werden.</div>;
  }

  return (
    <div
      className="min-h-screen"
      style={{ backgroundColor: theme.backgroundColor, color: theme.textColor }}
    >
      {/* Landscape */}
      <div className="flex h-screen">
        <div className="flex-1 md:w-1/3 flex flex-col items-start justify-start relative">
          {/* Logo */}
          <img src={logoUrl} alt="Logo" className="absolute top-12 left-12 h-14" />

          {/* Avatar */}
          <div className="absolute bottom-0 transform -translate-x-80">
            <Animation src={avatar} className={'object-contain portrait:h-full portrait:w-auto landscape:min-w-fit'}/>
          </div>
        </div>

        {/* Textbox */}
        <div
          className="flex flex-2 flex-col justify-center md:w-2/3 rounded-xl p-12 mr-16 my-28"
          style={{ backgroundColor: theme.foregroundColor }}
        >
          <div className="text-center mb-16">
            <ReactMarkdown className="text-5xl uppercase">{question}</ReactMarkdown>
          </div>

          {/* Tasten */}
          <div className="grid grid-cols-2 gap-6">
            {buttons.map((button, idx) => (
              <Button
                key={idx}
                buttonnumber={button.number}
                text={button.text}
                theme={theme}
                handleClick={() => {
                  if (button.route) {
                    navigate(button.route);
                  } else {
                    console.warn(`Button ${idx} does not have a valid route`);
                  }
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}